"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var netinfo_1 = require("@wora/netinfo");
var useIsConnected_1 = require("./internal/useIsConnected");
function useIsConnected() {
    return useIsConnected_1.useIsConnected(netinfo_1.NetInfo);
}
exports.useIsConnected = useIsConnected;
//# sourceMappingURL=useIsConnected.js.map